// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lC_7U","question":"styles_question__3bTEY","description":"styles_description__2lgKh"};